import { Injectable } from '@angular/core';
import { ITechnologyStack, SimpleStatus } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class StatusCalculatorService {
  calculateStatus(
    techDate: Partial<ITechnologyStack>,
    yearsInAdvanced = 0,
  ): SimpleStatus {
    let today = new Date();

    // Add yearsInAdvanced
    today.setFullYear(today.getFullYear() + yearsInAdvanced);
    let support: Date;
    let eol: Date;

    if (techDate.tech === 'react') {
      if (techDate.support === true) {
        return 'good';
      }

      support = new Date(techDate.support as any);
      if (today < support) {
        return 'danger';
      }
      return 'danger';
    } else if (techDate.tech === 'springboot' || techDate.tech === 'java') {
      support = new Date(techDate.eol as string);
      eol = new Date(
        techDate.extendedSupport && (techDate.extendedSupport as any) !== true
          ? (techDate.extendedSupport as string)
          : (techDate.support as any)!,
      );
    } else if (techDate.tech === 'angular' || techDate.tech === 'nodejs') {
      eol = new Date(techDate.eol as string);
      support = new Date(
        techDate.support
          ? (techDate.support as any)
          : (techDate.extendedSupport as string),
      );
    } else {
      eol = new Date(techDate.eol as string);
      support = new Date(
        techDate.support
          ? (techDate.support as any)
          : (techDate.extendedSupport as string),
      );
    }

    if (today > support && today < eol) {
      return 'caution';
    } else if (today < support) {
      return 'good';
    } else if (today > eol) {
      return 'danger';
    } else {
      return 'gray';
    }
  }

  /**
   * Convierte el StatusClass a la clase CSS correspondiente para la tabla
   */
  getStatusCssClass(status: any): string {
    switch (status) {
      case 'good':
        return 'status-green';
      case 'caution':
        return 'status-orange';
      case 'danger':
        return 'status-red';
      case 'gray':
      default:
        return 'status-gray';
    }
  }
}
